import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';
var useStyles = makeStyles(function (theme) { return ({
    root: function (_a) {
        var fieldWidth = _a.fieldWidth;
        return ({
            fontSize: theme.typography.fontSize || '12px',
            maxWidth: fieldWidth || 'inherit',
        });
    },
    labelContainer: {
        padding: '2px 0',
        fontSize: theme.typography.h6.fontSize,
    },
    labelLeft: {
        color: theme.palette.text.secondary || '#000000',
        fontWeight: 'bold',
    },
}); });
/**
 * @deprecated
 * Use `TopLabelInput` to render a text input with a label at the top
 */
function TopLabelInput(props) {
    var labelLeft = props.labelLeft, labelRight = props.labelRight, children = props.children;
    var classes = useStyles(props);
    return (React.createElement("div", { className: classes.root },
        React.createElement(Grid, { container: true, justify: 'space-between', className: classes.labelContainer },
            React.createElement(Grid, { item: true },
                React.createElement("label", { className: classes.labelLeft }, labelLeft)),
            React.createElement(Grid, { item: true },
                React.createElement("label", null, labelRight))),
        React.createElement("div", null, children)));
}
TopLabelInput.defaultProps = {
    fieldWidth: '100%',
    bordered: true,
};
export default TopLabelInput;
//# sourceMappingURL=TopLabelInput.js.map